/**
 * @param {import('axios').AxiosError|{ response?: { data?: { message?: string, data?: { profile_path?: string } } } }} error
 * @returns {{ message: string, profilePath: string|null }}
 */
export function getFacilityAssignmentError(error) {
  const data = error?.response?.data;
  const message = data?.message || 'Operation failed';
  const profilePath = data?.data?.profile_path || null;

  return { message, profilePath };
}
